import MobileAppLink from './MobileAppLink';

export default MobileAppLink;
